import {useEffect, useCallback} from 'react'
import debounce from 'lodash/debounce'
import {useHeaderContext} from '../contexts/header-context'

export const useHeaderHeight = () => {
    const {headerRef, headerHeight, setHeaderHeight, shouldShowSticky} = useHeaderContext()

    // Stable function to avoid unnecessary re-renders
    const calculateHeight = useCallback(() => {
        if (headerRef.current) {
            const height = headerRef.current.offsetHeight
            if (height !== headerHeight) {
                setHeaderHeight(height)
            }
        }
    }, [headerRef, headerHeight, setHeaderHeight])

    useEffect(() => {
        const debouncedCalculateHeight = debounce(calculateHeight, 300)

        // Calculate initial height
        calculateHeight()

        // Recalculate on resize
        window.addEventListener('resize', debouncedCalculateHeight)

        return () => {
            window.removeEventListener('resize', debouncedCalculateHeight)
            debouncedCalculateHeight.cancel()
        }
    }, [calculateHeight])

    // Recalculate height when sticky state changes
    useEffect(() => {
        calculateHeight()
    }, [shouldShowSticky, calculateHeight])

    return headerHeight
}
